import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import Colors from '@/constants/Colors';
import { maxWidth, pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

const imgFolder = process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST + '/img';

export const StyledPublicThemes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .content-wrapper {
    position: relative;
    width: 100%;
    .themes-section {
      position: relative;
      .title {
        position: relative;
        display: flex;
        align-items: center;
        gap: ${pxToVw(18)};
        &::before {
          content: '';
          position: absolute;
          left: ${pxToVw(-160)};
          top: 0;
          width: ${pxToVw(150)};
          background-image: url('${imgFolder}/public-page/arrow-right-themes.svg');
          background-size: ${pxToVw(150)};
          height: ${pxToVw(80)};
          background-repeat: no-repeat;
        }
        .themes-circle-icon {
          width: ${pxToVw(45)};
          height: ${pxToVw(45)};
        }
      }
      .themes-with-search {
        position: relative;
        padding: ${pxToVw(20)} 0 0;
        .search {
          margin-bottom: ${pxToVw(27)};
        }
        .themes {
          display: grid;
          align-items: flex-start;
          grid-gap: ${pxToVw(16)};
          grid-template-columns: repeat(2, 1fr);
        }

        .themes-not-in-tag {
          margin-top: 20px;
          padding: 5px 20px;
          background: ${Colors.backgroundPaleBlueDark};
          border-radius: 8px;
        }
      }
    }
  }

  .activity-type-links {
    margin: ${pxToVw(150)} 0 ${pxToVw(100)};
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: ${maxWidth}px;
    width: 100%;
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    .content-wrapper {
      .themes-section {
        .title {
          gap: 10px;
          margin-top: ${pxToVw(64)};
          margin-left: ${pxToVw(24)};
          ::before {
            background-size: ${pxToVw(150)};
            top: ${pxToVw(25)};
          }
          .themes-circle-icon {
            width: ${pxToVw(35)};
            height: ${pxToVw(35)};
          }
        }
        .themes-with-search {
          padding-top: ${pxToVw(64)};
          .search {
            margin-bottom: 30px;
          }
          .themes {
            grid-template-columns: 1fr;
            grid-gap: 16px;
          }
        }
      }
    }
  }
`;
